<div class="container-fluid pt-3">
    <i-title [text]="'Actions'">
        <div class="d-flex flex-row align-items-center gap-3">
            <div class="actions__filter">
                <idel-table-columns-filter [columns]="filterFields()"
                    [sessionStorageKey]="'points-list-table-column-filters'" (onFilter)="onFilterActions($event)"
                    (onReset)="onFilterReset()"></idel-table-columns-filter>
            </div>
            <div class="actions__scope">
                <div class="actions__scope__points cursor-pointer" [class.selected]="selectedScope() === 'points'"
                    (click)="onScopeChange('points')">Points</div>
                <div class="actions__scope__meetings cursor-pointer" [class.selected]="selectedScope() === 'meetings'"
                    (click)="onScopeChange('meetings')">Séances</div>
            </div>
        </div>
    </i-title>
</div>

<div class="my-3">
    <i-tabs-xl-v2 [tabs]="tabs()" [(currentTabId)]="currentTab" (onSelectTab)="onTabChange($event)"></i-tabs-xl-v2>
</div>

<div class="actions">
    <div class="actions__list">
        @if(fetchingActions()) {
        <span style="align-self: center;" class="mt-4">
            <i-loader></i-loader>
        </span>
        }@else {
        @for(action of filteredActions(); track action) {
        <idel-action-card [action]="action" [currentUser]="userInfos()" (onProcess)="onProcessActionClick($event)"
            [contacts]="contacts()" (naviguateToMeeting)="goToMeeting($event)"
            (naviguateToPoint)="goToPoint($event)"></idel-action-card>
        }@empty {
        <idel-empty-result-placeholder [options]="{showPageRefreshPossibility: false}"
            [emptyMessage]="'Aucune action pour le moment'"></idel-empty-result-placeholder>
        }
        }
    </div>
    <div class="actions__paginator">
        <p-paginator #paginator [rows]="currentLimit()" [first]="currentOffset()" [totalRecords]="result().totalCount"
            [rowsPerPageOptions]="[5, 10, 15, 20, 100]" (onPageChange)="onPageChange($event)"></p-paginator>
    </div>
</div>

<p-dialog [blockScroll]="true" [visible]="isActionProcessDialogOpen()"
    (visibleChange)="isActionProcessDialogOpen.set($event)" [header]="'Traiter l\'action'" [style]="{width: '30dvw'}">
    @if(actionToProcess()) {
    <idel-action-process [action]="actionToProcess()" (processed)="onActionProcessed()" [currentUser]="userInfos()"
        [scope]="selectedScope()"></idel-action-process>
    }
</p-dialog>